var _rect, _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeNeedGuidance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 30,
    viewBox: "0 0 96 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.125,
    width: 94.5,
    height: 27.75,
    rx: 13.875,
    stroke: "#FC5955",
    strokeWidth: 0.75
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1085_20165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9375 15C11.9375 15.8126 12.0975 16.6172 12.4085 17.3679C12.7194 18.1186 13.1752 18.8007 13.7498 19.3752C14.3243 19.9498 15.0064 20.4056 15.7571 20.7165C16.5078 21.0275 17.3124 21.1875 18.125 21.1875C18.9376 21.1875 19.7422 21.0275 20.4929 20.7165C21.2436 20.4056 21.9257 19.9498 22.5002 19.3752C23.0748 18.8007 23.5306 18.1186 23.8415 17.3679C24.1525 16.6172 24.3125 15.8126 24.3125 15C24.3125 14.1874 24.1525 13.3828 23.8415 12.6321C23.5306 11.8814 23.0748 11.1993 22.5002 10.6248C21.9257 10.0502 21.2436 9.59445 20.4929 9.2835C19.7422 8.97254 18.9376 8.8125 18.125 8.8125C17.3124 8.8125 16.5078 8.97254 15.7571 9.2835C15.0064 9.59445 14.3243 10.0502 13.7498 10.6248C13.1752 11.1993 12.7194 11.8814 12.4085 12.6321C12.0975 13.3828 11.9375 14.1874 11.9375 15Z",
    stroke: "#FC5955",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.125 12.25V15",
    stroke: "#FC5955",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.125 17.75V17.7575",
    stroke: "#FC5955",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4517 11.1815H40.1552V12.725C40.1552 14.7305 38.9477 16.7465 37.4357 17.492L36.9317 16.799C38.3072 16.148 39.4517 14.363 39.4517 12.725V11.1815ZM39.6197 11.1815H40.3232V12.725C40.3232 14.3315 41.4677 15.9695 42.8642 16.568L42.3707 17.261C40.8377 16.547 39.6197 14.699 39.6197 12.725V11.1815ZM37.2467 10.793H42.5492V11.528H37.2467V10.793ZM43.8302 9.827H44.7017V19.319H43.8302V9.827ZM47.6829 14.258H54.2034V14.972H47.6829V14.258ZM46.6014 17.3975H55.2009V18.1325H46.6014V17.3975ZM50.4444 14.5625H51.3159V17.6915H50.4444V14.5625ZM47.6829 10.583H54.1089V11.297H48.5544V14.573H47.6829V10.583ZM65.9484 9.827H66.8304V14.741H65.9484V9.827ZM60.6354 15.203H66.8304V17.492H61.5174V18.92H60.6669V16.841H65.9589V15.896H60.6354V15.203ZM60.6669 18.521H67.1769V19.214H60.6669V18.521ZM59.4594 10.4675H64.5519V11.1605H59.4594V10.4675ZM59.2914 14.426L59.1969 13.7015C60.8874 13.7015 63.1554 13.6595 65.0034 13.4285L65.0559 14.069C63.1659 14.3525 60.9609 14.4155 59.2914 14.426ZM60.3939 10.7825H61.2339V14.0165H60.3939V10.7825ZM62.7669 10.7825H63.6174V14.0165H62.7669V10.7825ZM70.7986 14.7095H71.6596V17.555H70.7986V14.7095ZM74.3056 14.7095H75.1771V17.555H74.3056V14.7095ZM68.6986 17.387H77.2981V18.1115H68.6986V17.387ZM72.9826 10.4255C74.9881 10.4255 76.4266 11.381 76.4266 12.872C76.4266 14.3525 74.9881 15.308 72.9826 15.308C70.9666 15.308 69.5281 14.3525 69.5281 12.872C69.5281 11.381 70.9666 10.4255 72.9826 10.4255ZM72.9826 11.1185C71.4601 11.1185 70.3681 11.8115 70.3681 12.872C70.3681 13.922 71.4601 14.615 72.9826 14.615C74.5051 14.615 75.5866 13.922 75.5866 12.872C75.5866 11.8115 74.5051 11.1185 72.9826 11.1185Z",
    fill: "#FC5955"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1085_20165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 16.5,
    fill: "white",
    transform: "translate(9.875 6.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeNeedGuidance);
export default __webpack_public_path__ + "static/media/badge_need_guidance.43aa3237d24ee427b5782bfe557af685.svg";
export { ForwardRef as ReactComponent };